module.exports = __webpack_public_path__ + "img/second.90c994d9.jpg";